/**
 * moray-recent.js — "Visto recientemente" REAL por localStorage (MORAY).
 * - Registra el handle de la PDP actual en 'moray:recent' (más reciente primero, máx 12).
 * - Pinta hasta `limit` productos del historial (excluyendo el actual) pidiendo cada
 *   tarjeta por Section Rendering: /products/<handle>?section_id=moray-recent-card.
 * - Sin historial → la sección sigue [hidden]. Fetch fallido (producto borrado/oculto)
 *   → se salta y se limpia del historial.
 * - Las flechas las mueve iurop-sliders.js (delegación global); aquí solo se rellena el track.
 */
(function () {
  'use strict';
  if (window.__morayRecentLoaded) return;
  window.__morayRecentLoaded = true;

  var KEY = 'moray:recent';
  var MAX = 12;

  function readList() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }

  function writeList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) { /* Safari privado */ }
  }

  function record(handle) {
    if (!handle) return;
    var list = readList().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    writeList(list);
  }

  function fetchCard(handle) {
    var url = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    url += 'products/' + encodeURIComponent(handle) + '?section_id=moray-recent-card';
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(handle); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('.iurop-product-card');
        if (!card) return Promise.reject(handle);
        card.querySelectorAll('script').forEach(function (s) { s.remove(); });
        return { handle: handle, card: card };
      });
  }

  function init(root) {
    if (root.dataset.morayRecentReady) return;
    root.dataset.morayRecentReady = '1';

    var current = root.dataset.currentHandle || '';
    record(current);

    var track = root.querySelector('[data-moray-recent-track]');
    if (!track) return;
    track.innerHTML = ''; // idempotente: un re-init (p.ej. shopify:section:load del preview) nunca duplica
    var limit = parseInt(root.dataset.limit, 10) || 6;
    var handles = readList().filter(function (h) { return h !== current; }).slice(0, limit);
    if (!handles.length) return; // sin historial: la sección queda oculta

    // Mantener el orden del historial aunque los fetch lleguen desordenados
    Promise.allSettled(handles.map(fetchCard)).then(function (results) {
      var dead = [];
      var ok = [];
      results.forEach(function (res, i) {
        if (res.status === 'fulfilled') ok.push(res.value);
        else dead.push(handles[i]);
      });
      if (dead.length) writeList(readList().filter(function (h) { return dead.indexOf(h) === -1; }));
      if (!ok.length) return;
      track.innerHTML = ''; // limpiar EN EL APPEND: dos inits en carrera (preview dispara section:load) nunca duplican
      ok.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'iurop-product-slider__slide';
        li.appendChild(item.card);
        track.appendChild(li);
      });
      root.hidden = false;
    });
  }

  function boot() {
    document.querySelectorAll('[data-moray-recent]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Editor de temas: re-render de la sección. SOLO en designMode — el modo
  // preview también emite section:load y provocaba un doble init en carrera.
  document.addEventListener('shopify:section:load', function (e) {
    if (!(window.Shopify && Shopify.designMode)) return;
    var root = e.target && e.target.querySelector && e.target.querySelector('[data-moray-recent]');
    if (root) { delete root.dataset.morayRecentReady; init(root); }
  });
})();
